import Header from '../layout/header';
import { useTheme } from '../theme/ThemeContext';

function SystemSettings() {
  const { theme, setTheme } = useTheme();

  const optionBase = {
    flex: '1 1 220px',
    minWidth: 'min(220px, 100%)',
    maxWidth: '320px',
    padding: '28px 24px',
    borderRadius: '16px',
    cursor: 'pointer',
    border: '2px solid var(--home-border, #444)',
    backgroundColor: 'var(--home-card-bg, #2a2d35)',
    transition: 'all 0.2s ease',
    textAlign: 'center',
  };

  return (
    <div className="main">
      <Header />
      <div
        className="page-content"
        style={{
          background: 'var(--home-page-bg, linear-gradient(135deg, #1e2127 0%, #2a2d35 100%))',
        }}
      >
        <h1
          style={{
            fontSize: 'clamp(24px, 5vw, 32px)',
            fontWeight: 700,
            margin: '0 0 12px 0',
            color: 'var(--home-heading, #fff)',
          }}
        >
          System Settings
        </h1>
        <p
          style={{
            fontSize: '16px',
            color: 'var(--home-muted, #888)',
            margin: '0 0 36px 0',
            maxWidth: '560px',
          }}
        >
          Choose appearance for the admin portal. Your preference is saved on this device.
        </p>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '20px',
            alignItems: 'stretch',
          }}
        >
          <button
            type="button"
            onClick={() => setTheme('light')}
            style={{
              ...optionBase,
              outline: theme === 'light' ? '3px solid #187718' : 'none',
              boxShadow: theme === 'light' ? '0 8px 24px rgba(24, 119, 24, 0.25)' : 'none',
            }}
          >
            <div style={{ fontSize: '42px', marginBottom: '12px' }} aria-hidden>☀️</div>
            <div
              style={{
                fontSize: '20px',
                fontWeight: 600,
                color: 'var(--home-heading, #fff)',
                marginBottom: '8px',
              }}
            >
              Light
            </div>
            <div style={{ fontSize: '14px', color: 'var(--home-muted, #888)' }}>
              Bright background and dark text
            </div>
          </button>

          <button
            type="button"
            onClick={() => setTheme('dark')}
            style={{
              ...optionBase,
              outline: theme === 'dark' ? '3px solid #187718' : 'none',
              boxShadow: theme === 'dark' ? '0 8px 24px rgba(24, 119, 24, 0.25)' : 'none',
            }}
          >
            <div style={{ fontSize: '42px', marginBottom: '12px' }} aria-hidden>🌙</div>
            <div
              style={{
                fontSize: '20px',
                fontWeight: 600,
                color: 'var(--home-heading, #fff)',
                marginBottom: '8px',
              }}
            >
              Dark
            </div>
            <div style={{ fontSize: '14px', color: 'var(--home-muted, #888)' }}>
              Default TecGym admin look
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}

export default SystemSettings;
